<template>
    <div>
        <el-dialog
            title="编辑房源"
            :visible.sync="showdialog"
            width="1200px"
            :before-close="back">
            <div class="warp">
                <div class="conrow">
                    <div class="t-cell">
                        <div class="t-title">基本信息</div>
                        <div class="t-content">
                            <el-form :model="house" ref="form" label-width="80px" :inline="false" size="mini">
                                <el-form-item label="房源名称">
                                    <el-input v-model="house.name" placeholder="请填写房源名称标题"></el-input>
                                </el-form-item>
                                <el-form-item label="地址 ">
                                    <div class="address-input" @click="showmap">{{house.location.address||'点击开始选择位置'}}</div>
                                </el-form-item>
                                <el-form-item label="面积">
                                    <el-input v-model="house.area" type="number" placeholder="请填写房源面积"><i slot="suffix">㎡</i></el-input>
                                </el-form-item>
                                <el-form-item label="起拍价">
                                    <el-input v-model="house.start_price" type="number" placeholder="房源起拍价格"><i slot="prefix">￥</i><i slot="suffix">万</i></el-input>
                                </el-form-item>
                                <el-form-item label="指导价">
                                    <el-input v-model="house.original_price" type="number" placeholder="房源指导价格"><i slot="prefix">￥</i><i slot="suffix">万</i></el-input>
                                </el-form-item>
                                <el-form-item label="房型">
                                    <p class="text">
                                        <el-input-number v-model="house.housetype.room" controls-position="right" :min="0" :max="99"></el-input-number>室
                                    </p>
                                    <p class="text">
                                        <el-input-number v-model="house.housetype.hall" controls-position="right" :min="0" :max="99"></el-input-number>厅
                                    </p>
                                    <p class="text">
                                        <el-input-number v-model="house.housetype.kitchen" controls-position="right" :min="0" :max="99"></el-input-number>厨
                                    </p>
                                    <p class="text">
                                        <el-input-number v-model="house.housetype.toilet" controls-position="right" :min="0" :max="99"></el-input-number>卫
                                    </p>
                                </el-form-item>
                                <el-form-item label="缩略图">
                                    <el-upload
                                        class="upload-demo"
                                        action="/api/Upload/uploadFile/"
                                        :on-success="handleAvatarSuccess"
                                        drag>
                                        <el-image v-if="house.thumbnail" :src="house.thumbnail" class="avatar" fit="contain"></el-image>
                                        <div v-else>
                                            <i class="el-icon-upload"></i>
                                            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                                            <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过1M</div>
                                        </div>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item>
                                    <el-button type="primary" @click="save">保存</el-button>
                                </el-form-item>
                            </el-form>
                            
                        </div>
                    </div>
                </div>
            </div>
            <tencent-map @getlocation="getlocation" :lat="house.location.lat" :lng="house.location.lng"></tencent-map>
        </el-dialog>
    </div>
</template>

<script>
import TencentMap from '../../../components/invest/tencent-map.vue';
export default {
    components: {
        TencentMap,
    },
    data() {
        return {
            showdialog: true,
            house: {
                name: '',
                area: '',
                housetype: {
                    room: 0,
                    hall: 0,
                    kitchen: 0,
                    toilet: 0,
                },
                region: '',
                start_price: '',    //起拍价
                original_price: '',     //指导价
                thumbnail: '',      //缩略图
                location: {},
                city: '',
            },
            id: '',
        }
    },
    mounted () {
        var id = this.$route.query.id;
        if (id) {
            this.id = id;
            this.gethouseinfo();
        }
    },
    methods: {
        gethouseinfo() {
            var params = {
                id: this.id
            }
            this.$api.getforeclosurevsid(params)
                .then(data=>{
                    let {house} = data;
                    this.house = house;
                })
        },
        getlocation(item) {
            if (item.address){
                this.house.location = item;
                this.house.city = item.city;
                this.house.region = item.district;
            }
            
        },
        showmap() {
            this.$store.commit('setshowtmap', true)
        },
        save() {
            var params = {
                id: this.id,
                name: this.house.name,
                area: this.house.area,
                housetype: this.house.housetype,
                region: this.house.region||'',
                start_price: this.house.start_price,    //起拍价
                original_price: this.house.original_price,     //指导价
                thumbnail: this.house.thumbnail,      //缩略图
                location: this.house.location,
                city: this.house.city,
            }
            if (this.id) {
                this.$api.foreclosureupdatebaseinfo(params)
                    .then(data=>{
                        this.$message.success(data);
                    })
                return;
            }
            this.$api.addforeclosurehouse(params)
                .then(data=>{
                    this.$message.success('添加房源成功');
                    this.$router.go(-1);
                })
        },
        back() {
            this.$router.go(-1);
        },
        handleAvatarSuccess(e) {
            let {data, msg} = e;
            if (data){
                this.$message.success(msg);
                this.house.thumbnail = data;
            } else {
                this.$message.error(msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG  = file.type === 'image/png';
            // const isLt2M = file.size / 1024 / 1024 < 1;
            if (!isJPG&&!isPNG) {
                this.$message.error('只能上传图片，不能上传其他文件!');
            }
            // if (!isLt2M) {
            //     this.$message.error('上传的图片大小不能超过 1MB!');
            // }

            return isJPG||isPNG;
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-textarea__inner{
    height: 200px;
}
::v-deep .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
::v-deep .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
::v-deep .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 350px;
    height: 176px;
    line-height: 176px;
    text-align: center;
}
.avatar {
    width: 360px;
    height: 178px;
    display: block;
}
.address-input{
        -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 28px;
    line-height: 28px;
    outline: 0;
    padding: 0 15px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    width: 100%;
    font-size: 12px;
}
</style>